<template>
    <BaseDropdown :is-open="isOpen" @toggle="handleToggle" style="width: unset;" id="language-menu">
        <template #trigger>
            <div class="active-language">
                <div v-if="isLoading" class="loader">
                    <PreloaderBase :size="'sm'" />
                </div>
                <span v-else>{{ currentLanguage }}</span>
                <span v-show="!isLoading" class="icon-chevron-down" :class="{ 'rotate-icon': isOpen }"></span>
            </div>
        </template>

        <template #content>
            <div class="language-menu">
                <template v-for="lang in languages" :key="lang">
                    <button
                        v-if="lang !== currentLanguage"
                        class="language-menu__item"
                        @click="changeLocation(lang)"
                    >
                        {{ lang }}
                    </button>
                </template>
            </div>
        </template>
    </BaseDropdown>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { TRANSLATE_LANGUAGES } from "@/data/countriesLanguageList";
import PreloaderBase from "@/components/Recurring/PreloaderBase";
import BaseDropdown from "@/components/ui/BaseDropdown.vue";

const store = useStore();
const isOpen = ref(false);
const isLoading = ref(false);
const languages = TRANSLATE_LANGUAGES;

const currentLanguage = computed(() => store.getters["auth/getLanguage"]);

const handleToggle = (value) => {
    isOpen.value = value;
};

const changeLocation = async (language) => {
    isOpen.value = false;
    isLoading.value = true;
    await store.dispatch("auth/updateLanguage", language);
    isLoading.value = false;
};
</script>

<style lang="scss">
#language-menu {
    width: 66px !important;
    min-width: unset;
}
</style>

<style lang="scss" scoped>
.active-language {
    height: 55px;
    width: 66px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    border-radius: 9px;
    background-color: var(--block-color);

    span {
        font-family: Gilroy;
        font-size: 0.9rem;
        font-weight: 600;
        text-transform: uppercase;
        color: rgba(#030303ff, 0.67);
    }

    .icon-chevron-down {
        font-size: 7px;
        color: rgba(#000000ff, 0.67);
        transition: transform 0.25s ease;

        &.rotate-icon {
            transform: rotate(180deg);
        }
    }

    &:hover {
        cursor: pointer;
        span {
            color: var(--general-color);
        }
    }
}

.language-menu {
    padding: 8px 0;

    &__item {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 8px 16px;
        border: none;
        background: none;
        text-align: left;
        cursor: pointer;
        font-family: Gilroy;
        font-size: 0.9rem;
        font-weight: 600;
        text-transform: uppercase;
        color: rgba(#030303ff, 0.67);
        transition: background-color 0.2s;

        &:hover {
            background-color: #f5f5f5;
            color: var(--general-color);
        }
    }
}

.loader {
    margin-bottom: 28px;
}
</style>
